import type { HistoryState } from '@tanstack/react-router'

/**
 * The saved view each grid's table came from, by grid ID, kept with the history entry rather than the URL. Typed here
 * instead of augmenting `@tanstack/history`, which is not a direct dependency and does not resolve under Bazel.
 */
type RecordedOrigins = { dataGridOrigins?: Readonly<Record<string, unknown>> }

export function recordedOrigin(state: HistoryState, gridId: string): string | null {
  const recorded = (state as RecordedOrigins).dataGridOrigins?.[gridId]
  return typeof recorded === 'string' ? recorded : null
}

export function withRecordedOrigin<State extends HistoryState>(
  state: State,
  gridId: string,
  savedViewId: string | null,
): State {
  const { [gridId]: _replaced, ...others } = (state as RecordedOrigins).dataGridOrigins ?? {}
  const next = { ...state } as State & RecordedOrigins
  if (savedViewId !== null) next.dataGridOrigins = { ...others, [gridId]: savedViewId }
  else if (Object.keys(others).length > 0) next.dataGridOrigins = others
  else delete next.dataGridOrigins
  return next
}
